import mapValues from 'lodash/mapValues';
import apiRequest from '@/js/helpers/apiRequest';

const url = '/component/action/book24:geo.location.popup/getCitiesOfRegion/';

async function post(data = {}) {
  const { DATA: { CITY } } = await apiRequest.post(url, {
    regionName: data.name,
    regionCode: data.location,
  });

  return {
    cities: [mapValues(CITY, letter => letter.map(city => ({
      name: city.CITY_NAME,
      location: city.CODE,
    })))],
  };
}

export default { post };
